<h2 mat-dialog-title>{{ 'TRACEABILITY.SAVE_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content *ngIf="types">
  <form [formGroup]="form" class="aio-save-content">
    <ul class="aio-save-content-list">
      <li>
        <mat-form-field>
          <mat-label>{{ 'TRACEABILITY.SAVE_DIALOG.LABEL' | translate }}</mat-label>
          <input matInput formControlName="label" type="text" autocomplete="off" required>
        </mat-form-field>
      </li>
      <li>
        <mat-form-field>
          <mat-label>{{ 'TRACEABILITY.SAVE_DIALOG.TYPE' | translate }}</mat-label>
          <mat-select formControlName="type" required>
            <mat-option *ngFor="let option of types" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </li>
    </ul>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="accent" mat-flat-button (click)="save()">
    {{ 'DIALOG.OK' | translate }}
  </button>
</mat-dialog-actions>